import React from "react";
import styled from "styled-components";
import Header from '@/components/Header'
import  bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'
import { Toast} from 'antd-mobile'
const isStorm = bwmodel.app === 'storm';

const ServiceCode = () => {
  const handleSaveImg = () => {
   
      Toast.loading('正在保存...', 1.4)

      const img = new Image();
      img.crossOrigin = 'Anonymous'; // 如果是跨域图片，需要设置这个属性
      img.src = require('./img/mmexport1744014449194.jpg'); // 设置图片源地址
      img.onload = function() {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          const dataUrl = canvas.toDataURL('image/png'); // 可以改为image/jpeg根据需要
          
          bridge.callHandler('nativeEvent', {
            event: "saveImage",
            params: {
              imageData: dataUrl.replace('data:image/png;base64,', ''),
            }
          }, res => {
            Toast.hide()
            const result = JSON.parse(res);
            if (result.code === 0) {
              Toast.info('已保存到相册')
            } else {
              Toast.info('保存失败')
            }
          })
          
      };
    
   
  }

  // function downloadImage(imageUrl, fileName = 'image.png') {
  //   const img = new Image();
  //   img.crossOrigin = 'Anonymous';
  //   img.onload = () => {
  //     const canvas = document.createElement('canvas');
  //     const ctx = canvas.getContext('2d');
  //     canvas.width = img.width;
  //     canvas.height = img.height;
  //     ctx.drawImage(img, 0, 0);
  
  //     canvas.toBlob(blob => {
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.download = fileName;
  //       link.href = url;
  //       link.click();
  //       URL.revokeObjectURL(url);
  //     }, 'image/png');
  //   };
  //   img.src = imageUrl;
  // }  
  const handleLeftClick = () => {
    
        bridge.callHandler('nativeEvent', {event: 'close', params: {
          isDelete: false
        }}, () => {})
      // }
    }
  return (
    <div>
      {
        isStorm && <Header
          title={'热点脉冲'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
        />
      }

      <ServiceCodeBox className="service-code-block"  style={{marginTop: isStorm?'44px':'0px'}}>
        <div data-v-04b7e8ac="" class="box">
         
         <div data-v-04b7e8ac="" class="code-box">
          <div data-v-04b7e8ac="" class="title"> 欢迎添加客服</div> 
          <div data-v-04b7e8ac="img-box">
          
            <img data-v-04b7e8ac="" src={require('./img/mmexport1744014449194.jpg')} alt=""></img>
          </div>
              
            
            {
              isStorm?  <div data-v-04b7e8ac="" class="tips">请截图用微信扫码 添加企微客服咨询购买服务</div>
              :<div data-v-04b7e8ac="" class="tips">长按二维码添加企微客服 咨询购买服务</div>
            }
            </div>
          </div>
          {
            isStorm && <button onClick={
              handleSaveImg
            }>  
            <img data-v-04b7e8ac="" src={require('./img/下载.png')} alt=""></img>
        保存二维码</button>
          
        }
      </ServiceCodeBox>
    </div>
  )
}

export default ServiceCode

export const ServiceCodeBox = styled.div`
  // background: linear-gradient  #FFFFFF 0%, #FEF3D5 100%);
  background-image: linear-gradient(180deg, #FEF3D5, #FFFFFF);

  backdrop-filter: blur(10px);
  background-repeat: no-repeat;
  background-size: 100% 130px;
  min-height: 100vh;
  padding-top:64px;
  .code-box {
    text-align: center;
    margin: 0 20px;
    padding: 23px;
    background: red;
    background: linear-gradient( 180deg, #FFFEFD 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 20px 0px rgba(217,109,0,0.1);
    border-radius: 20px;
  }
  .title {
    font-size: 14px;
    color: #293241;
    }
  img {
    max-width: 100%;
  }
  .tips {
    margin-top: 0px;
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
  }
  button {
    width: 170px;
    height: 40px;
    background: #FFD745;
    border-radius: 20px;
    text-align: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    border: none;
    margin: 29px auto;
    display: block;
    img{
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
      margin-top: -4px;
      line-height: 21px;

    }
  }
}`


// WEBPACK FOOTER //
// ./src/views/activity_148/code.js